"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#000000' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.49997 3.33317V1.6665M12.5 16.6665V18.3332M3.3333 7.49985H1.66663M16.6667 12.4999H18.3333M4.09514 4.09502L2.91663 2.91651M15.9048 15.9047L17.0833 17.0832M9.99998 14.7139L8.23221 16.4817C6.93046 17.7834 4.8199 17.7834 3.51815 16.4817C2.2164 15.1799 2.2164 13.0694 3.51815 11.7676L5.28592 9.99985M14.714 9.99985L16.4818 8.23208C17.7836 6.93033 17.7836 4.81978 16.4818 3.51803C15.1801 2.21628 13.0695 2.21628 11.7677 3.51803L9.99998 5.2858",
    stroke: fill,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

exports["default"] = _default;